<template>
  <div class="component-mobile-sidebar">
    <img src="https://p4.ssl.qhimg.com/t110b9a93012512ec77d5c54ef6.png" alt="" class="sidebar-logo" />
    <img
        @click="showPopup"
        src="https://p0.ssl.qhimg.com/t110b9a93015826907866b624e3.png"
        alt=""
        class="sidebar-more"
      />
  </div>
  <van-popup v-model:show="show" position="bottom">
    <div
      @click="handleClick(item.href, item.key, item.path, item.routePath)"
      v-for="(item, index) in menu"
      :key="item.key"
      class="sidebarLi"
    >
      <a href="javascript:void(0);">{{ item.title }}</a>
    </div>
  </van-popup>
</template>

<script setup>
import { ref } from 'vue'
const show = ref(false)

const menu = [
{
    key: 'index',
    title: '首页',
    routePath: 'new/2025.html'
  },
  {
    key: 'previous',
    title: '往届回顾',
    path: 'https://isc.360.com/new/events/history.html'
  }
]
const showPopup = () => {
  show.value = true
}

const handleClick = (href, key, path, routePath) => {
  show.value = false
  if(href) {
    scrollToSection(href)
  }else if (key === 'agenda') {
    const baseUrl = window.location.origin
    window.open(`${baseUrl}${path}`, '_blank')
    return
  }else if(path) {
    window.open(path, '_blank')
  }else if(routePath){
    const path = `${window.location.origin}/${routePath}`
    location.href = path
  }
}

const scrollToSection = (href) => {
  const element = document.querySelector(href)
  if (element) {
    window.scrollTo({
      top: element.offsetTop,
      behavior: 'smooth'
    })
  }
}
</script>

<style lang="scss" scoped>
.component-mobile-sidebar {
  width: 100%;
  height: 60px;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  padding: 0 20px;

  .sidebar-logo {
    height: 36px;
  }
  .sidebar-more{
    height: 32px;
    width: 28px;
  }
}
.van-popup {
  padding-top: 24px;
  border-radius: 32px 32px 0 0;
  .sidebarLi {
    text-align: center;
    margin-bottom: 24px;
    a {
      color: #525966;
    }
  }
}
</style>
